export default {"src":"/_next/static/media/Access-25th-Logo.ffc4c086.svg","height":190,"width":600};